<script setup lang="ts">
import { ref } from "vue";

const props = defineProps<{
  variant: "laptop" | "phone";
  src: string;
  alt: string;
  placeholder: string;
}>();

const failed = ref(false);
</script>

<template>
  <div class="device" :class="`device--${props.variant}`">
    <div v-if="props.variant === 'laptop'" class="device__chrome">
      <span /><span /><span />
    </div>

    <div class="device__screen">
      <img
        v-if="!failed"
        :src="props.src"
        :alt="props.alt"
        @error="failed = true"
      />
      <div v-else class="device__placeholder">
        <img src="/branding/klupz-logo.svg" alt="" aria-hidden="true" />
        <span>{{ props.placeholder }}</span>
      </div>
    </div>

    <img
      v-if="props.variant === 'phone'"
      class="device__frame"
      src="/mockups/iphone-16-black.png"
      alt=""
      aria-hidden="true"
    />
  </div>
</template>

<style scoped lang="scss">
.device {
  position: absolute;
  border-radius: 14px;
  background: rgb(var(--v-theme-surface));
  box-shadow: 0 24px 60px -24px rgba(15, 23, 42, 0.28);
  overflow: hidden;
  border: 1px solid rgb(var(--v-theme-border));

  &--laptop {
    top: 0;
    left: 0;
    width: 100%;
  }

  &--phone {
    right: 4%;
    bottom: -14%;
    width: 29%;
    aspect-ratio: 1359 / 2736;
    background: none;
    border: none;
    border-radius: 0;
    box-shadow: none;
    overflow: visible;
  }
}

.device__chrome {
  height: 30px;
  background: rgb(var(--v-theme-secondary));
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  border-bottom: 1px solid rgb(var(--v-theme-border));

  span {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: rgb(var(--v-theme-border));
  }
}

.device__screen {
  position: relative;
  aspect-ratio: 16 / 10.4;
  background: rgb(var(--v-theme-secondary));

  .device--phone & {
    position: absolute;
    top: 3.29%;
    left: 6.62%;
    width: 86.76%;
    height: 93.42%;
    border-radius: 9% / 4.4%;
    overflow: hidden;
  }

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
}

.device__frame {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
  filter: drop-shadow(0 20px 40px rgba(15, 23, 42, 0.32));
}

.device__placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  padding: 16px;
  background:
    radial-gradient(
      circle at 20% 15%,
      rgba(76, 156, 219, 0.16),
      transparent 55%
    ),
    radial-gradient(
      circle at 85% 85%,
      rgba(222, 17, 91, 0.14),
      transparent 55%
    ),
    rgb(var(--v-theme-secondary));

  img {
    position: static;
    height: 22px;
    width: auto;
    opacity: 0.85;
  }

  span {
    font-size: 11.5px;
    font-weight: 600;
    color: rgb(var(--v-theme-emphasis));
  }
}
</style>
